/**
 * Cookie consent helpers. Stores user choice in localStorage:
 *   { necessary: true, functional: bool, analytics: bool, ts: ISO }
 * Necessary is always true (cannot be disabled).
 */

const KEY = "qht_cookie_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (typeof v !== "object" || !v) return null;
    return { necessary: true, functional: !!v.functional, analytics: !!v.analytics, ts: v.ts || "" };
  } catch {
    return null;
  }
}

export function saveConsent(choice) {
  const v = {
    necessary: true,
    functional: !!choice?.functional,
    analytics: !!choice?.analytics,
    ts: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(v));
  window.dispatchEvent(new CustomEvent("qht-consent-change", { detail: v }));
  return v;
}

export function acceptAll() {
  return saveConsent({ functional: true, analytics: true });
}

export function rejectAll() {
  // necessary only
  return saveConsent({ functional: false, analytics: false });
}

export function openSettings() {
  window.dispatchEvent(new CustomEvent("qht-open-cookie-settings"));
}
